export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/front/change_pay',
      name: 'distributor-train-front-change_pay',
      component: () => import('./index.vue'),
    },
  ]
};
